// TODO: Add some generic mechanism to handle errors and remove string comparison

const DEFAULT_MESSAGE_CODES = [500];

const UNHANDLED_ERROR_MESSAGES = [
  'Internal server error',
  'Unhandled organization pipe exception occurred',
  'Request failed with status code 403',
  'Request failed with status code 400',
  'Request failed with status code 500',
];

export const extractErrorMessage = (
  error: unknown,
  defaultMessage: string = '',
  {
    defaultMessageStatusCodes = DEFAULT_MESSAGE_CODES,
  }: {
    defaultMessageStatusCodes?: number[];
  } = {}
) => {
  const errorMessage = (() => {
    if (typeof error === 'string') {
      return error;
    }
    if (
      error &&
      typeof error === 'object' &&
      'status' in error &&
      typeof error.status === 'number'
    ) {
      if (defaultMessageStatusCodes.includes(error.status))
        return defaultMessage;
    }

    if (
      error &&
      typeof error === 'object' &&
      'response' in error &&
      error.response
    ) {
      if (typeof error.response === 'string') return error.response;

      if (typeof error.response === 'object' && 'data' in error.response) {
        if (typeof error.response.data === 'string') return error.response.data;

        if (
          typeof error.response.data === 'object' &&
          error.response.data &&
          'message' in error.response.data &&
          typeof error.response.data.message === 'string'
        )
          return error.response.data.message;
      }
    }

    if (error instanceof Error) {
      return error.message;
    }

    return defaultMessage;
  })();

  return UNHANDLED_ERROR_MESSAGES.includes(errorMessage)
    ? defaultMessage
    : errorMessage || defaultMessage;
};
